import React from 'react';
import Link from '@/helpers/Link';
import { resourceHelpers } from '@/utils/helpers';
import { VerifyInfo } from './VerifyInfo';
import ResourceIcon from '@/components/Resources/ResourceIcon/ResourceIcon';

const titleContent = (resource, additionalClass, displayVerification) => (
  <>
    {resource.resource_type == 'Opportunity' ? resource.title : resource.name}
    {displayVerification && (
      <span className={additionalClass.verifyCheck}>
        <VerifyInfo resource={resource} />
      </span>
    )}
  </>
);

const OrgNameAndTitlePanel = ({ resource, additionalClass, linkTitle, linkSubtitle, displayVerification = false, displayIcon = false }) => {
  return (
    <>
      <div>
        {displayIcon && (
          <span>
            <ResourceIcon resource={resource} className={additionalClass.resourceIcon} />
          </span>
        )}
        <div className={additionalClass.nameTitleWrapper}>
          <div>
            {linkTitle ? (
              <Link href={resourceHelpers.pathTo(resource)} className={additionalClass.oppName}>
                {titleContent(resource, additionalClass, displayVerification)}
              </Link>
            ) : (
              <span className={additionalClass.oppName}>{titleContent(resource, additionalClass, displayVerification)}</span>
            )}
          </div>
          {linkSubtitle ? (
            <Link href={resourceHelpers.pathTo(resource.organization)} className={additionalClass.orgName}>
              {resource?.organization?.name}
            </Link>
          ) : (
            <span className={additionalClass.orgName}>{resource?.organization?.name}</span>
          )}
        </div>
      </div>
    </>
  );
};

export default OrgNameAndTitlePanel;
